/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScannerRuleBase {
    getFixupPrototypeFunction() { return ScannerRuleBase.fixupPrototype; }

    static newInstance(model: Partial<ScannerRuleBase>): ScannerRuleBase {
        let obj = Object.assign(new ScannerRuleBase(), model);
        ScannerRuleBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScannerRuleBase>): ScannerRuleBase {
        if (!model) return null;
        return ScannerRuleBase.newInstance(<ScannerRuleBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScannerRuleBase) {
        if (!obj) return;

        models.ScannerRuleBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScannerRuleBase): boolean {
        Object.setPrototypeOf(obj, ScannerRuleBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * name of the rule which are scanned against the resource configurations.
     */
    name: string;

    /**
     * description of the rule which are scanned against the resource configurations.
     */
    description: string;

    /**
     * resource type which are scanned against the resource configurations.
     */
    applicable_resource: string;

    /**
     * The input with which the rules are getting scanned.
     */
    input_details: Array<string>;

    /**
     * Identity of the rule which are scanned against the resource configurations.
     */
    sys_id: string;

    /**
     * attribute name for which the values are going to be stored.
     */
    attribute_name: string;

}
